import React, { useContext } from 'react';
// import { Menu, X } from 'lucide-react'; // Optional: Lucide icons for hamburger
// import { useNavigate } from 'react-router-dom';
import San from '../../Images/SAN Techn-logo.png'
// import Login from './Login';

import { FormContext } from '../Provider';

export default function AdminHeader() {
    const { Auth } = useContext(FormContext)
    // const [menuOpen, setMenuOpen] = useState(false);

    // const handleToggle = () => {
    //     setMenuOpen(!menuOpen)
    // }

    // const navigate = useNavigate()
    const url = process.env.REACT_APP_URL
    const Logout = () => {
        fetch(`${url}/logout`, {
            method: "DELETE",
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                window.location.href = '/'
                console.log(data)
            })
            .catch(err => {
                console.log("Error :", err)
                alert("Trouble in connecting to Server")
            })
    }
    // const [isAuth, setAuth] = useState(false)
    const handleClick = () => {

        window.location.href = '/admin/login'

    }

    return (
        <header className="bg-slate-100 text-white shadow-md sticky top-0 z-50">
            <div className="  md:px-10 py-6 flex justify-between items-center">
                {/* Title */}

                <img src={San} alt="San Technonation" className="h-20 object-contain " />
                <div className="text-xl md:text-2xl font-semibold">
                    <span className=" hidden md:block text-secondary-900 ">Student Admission</span>
                </div>

                {/* Desktop Buttons */}
                <div className="block gap-4 px-4">

                    {
                        Auth ? (

                            <button className="bg-red-500 px-4 py-2 rounded hover:bg-red-600 transition font-medium" onClick={Logout}>Logout</button>
                        ) : (
                            <button className="bg-white text-blue-900 px-4 py-2 rounded hover:bg-blue-200 transition" onClick={handleClick}>Login</button>
                        )


                    }



                </div>

                {/* Mobile Hamburger */}
                {/* <button className="md:hidden" onClick={handleToggle}>
                    {menuOpen ? <X size={24} /> : <Menu size={24} />}
                </button> */}
            </div>

            {/* Mobile Menu */}
            {/* {menuOpen && ( */}
                <div className="md:hidden px-4 pb-4 flex flex-row gap-2">

                    {
                        Auth ? (

                            <button className="bg-red-500 px-4 py-2 rounded hover:bg-red-600 transition" onClick={Logout}>Logout</button>
                        ) : (
                            <button className="bg-white text-blue-900 px-4 py-2 rounded hover:bg-blue-200 transition" onClick={handleClick}>Login</button>
                        )
                    }
                </div>
            {/* )} */}
        </header>
    );
}


